// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner-simple-view {
  width: 100%;
  height: 130px;
  overflow: hidden;
}
.banner-simple-view.tall {
  height: 320px;
}
.banner-simple-view .filtered-image {
  background-size: cover !important;
  background-repeat: no-repeat !important;
}
.banner-simple-view .overlay-filter {
  display: flex;
  align-items: center;
}
.banner-simple-view .overlay-filter .banner-content {
  width: 100%;
  margin-right: 30px;
  margin-left: 60px;
}
.banner-simple-view .overlay-filter .banner-content h1 {
  color: #ffffff;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-bottom: 15px;
  margin-top: 15px;
}
.banner-simple-view .overlay-filter .banner-content .description {
  width: 50%;
  color: white;
}
@media only screen and (max-width: 600px) {
  .banner-simple-view {
    height: 90px;
  }
  .banner-simple-view.tall {
    height: 90px;
  }
  .banner-simple-view .banner-content {
    margin-left: 21px;
    margin-right: 10px;
  }
  .banner-simple-view .banner-content .description {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/BannerSimple/styles.less"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,gBAAA;AACJ;AACI;EACI,aAAA;AACR;AAPA;EAUQ,iCAAA;EACA,uCAAA;AAAR;AAXA;EAeQ,aAAA;EACA,mBAAA;AADR;AAfA;EAoBY,WAAA;EACA,kBAAA;EACA,iBAAA;AAFZ;AApBA;EAyBgB,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAFhB;AA5BA;EAkCiB,UAAA;EACA,YAAA;AAHjB;AAUQ;EAAA;IACI,YAAA;EAPV;EASU;IACI,YAAA;EAPd;EAGM;IAQQ,iBAAA;IACA,kBAAA;EARd;EADM;IAYY,aAAA;EARlB;AACF","sourcesContent":[".banner-simple-view {\n    width: 100%;\n    height: 130px;\n    overflow: hidden;\n\n    &.tall {\n        height: 320px;\n    }\n    \n    .filtered-image {\n        background-size: cover !important;\n        background-repeat: no-repeat !important;\n    }\n    \n    .overlay-filter {\n        display: flex;\n        align-items: center;\n        \n\n        .banner-content {\n            width: 100%;\n            margin-right: 30px;\n            margin-left: 60px;\n\n            h1 {\n                color: #ffffff;\n                overflow: hidden;\n                white-space: nowrap;\n                text-overflow: ellipsis; \n                margin-bottom: 15px;\n                margin-top: 15px;\n            }\n\n            .description  {\n                 width: 50%; \n                 color: white;\n             }\n        }\n    }\n\n    // Mobile views\n    @media only screen {\n        @media (max-width: 600px) {\n            height: 90px;\n\n            &.tall {\n                height: 90px;\n            }\n\n            .banner-content {\n                margin-left: 21px;\n                margin-right: 10px;\n\n                .description  {\n                    display: none;\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
